import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
// import {
//   NbAuthComponent
//   // NbLoginComponent,
//   // NbLogoutComponent,
//   // NbRegisterComponent,
//   // NbRequestPasswordComponent,
//   // NbResetPasswordComponent,
// } from '@nebular/auth';
import { AuthRedirectComponent } from './auth-redirect/auth-redirect.component';
// import { NbAuthComponent } from '@nebular/auth';
// import { RegistrationComponent } from './auth/registration/registration.component';

export const routes: Routes = [
  {
    path: 'pages', loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule)
  },
  {
    path: 'auth_redirect/:page/:token/:campus',
    component: AuthRedirectComponent
  },
  {
    path: 'public',
    loadChildren: () => import('./public/public.module').then(m => m.PublicModule)
  },
  // {
  //   path: 'auth',
  //   // component: NbAuthComponent,
  //   children: [
  //     {
  //       path: '', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  //     },
  //     //   // {
  //     //   //   path: 'register',
  //     //   //   component: RegistrationComponent
  //     //   // },
  //     //   // {
  //     //   //   path: 'login',
  //     //   //   component: NbLoginComponent,
  //     //   // },
  //     //   // {
  //     //   //   path: 'reg',
  //     //   //   component: NbRegisterComponent,
  //     //   // },
  //     //   // {
  //     //   //   path: 'logout',
  //     //   //   component: NbLogoutComponent,
  //     //   // },
  //     //   // {
  //     //   //   path: 'request-password',
  //     //   //   component: NbRequestPasswordComponent,
  //     //   // },
  //     //   // {
  //     //   //   path: 'reset-password',
  //     //   //   component: NbResetPasswordComponent,
  //     //   // },
  //   ],
  // },
  { path: '', redirectTo: 'public', pathMatch: 'full' },
  // { path: '**', redirectTo: 'pages' },
];

const config: ExtraOptions = {
  useHash: true,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
